import { DEFAULT_NOTE_OPTIONS, type Category, type Product } from '../types'

/**
 * Which note options an item offers.
 *
 * Three levels, most specific first: the product, then its category, then the
 * built-in list. The fallback chain is what makes this practical to set up,
 * a yurt writes one list per category and only touches individual products
 * where they differ.
 *
 * An empty array is a real answer, not a missing one: "İçecek" set to no
 * options is how a bottle of water stops being asked whether it wants onion.
 * So the check is for null/undefined, never for length.
 */
export function noteOptionsFor(product: Product, categories: Category[]): string[] {
  if (product.noteOptions != null) return product.noteOptions

  const category = categories.find((c) => c.id === product.categoryId)
  if (category?.noteOptions != null) return category.noteOptions

  return DEFAULT_NOTE_OPTIONS
}
